import { default as MuiCardContent } from '@material-ui/core/CardContent';

const CardContent = MuiCardContent;

export default CardContent;
